import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const acceptHandoff = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('accept_handoff', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyAccept')
		return null
	}
	try {
		const updated = await port.acceptHandoff(item.id, ctx.actorId, ctx.actorName)
		notify.success('workItem.accepted')
		return updated
	} catch {
		notify.error('workItem.acceptFailed')
		return null
	}
}

export { acceptHandoff }
